import { brand } from "./brands";

const toCssName = (name) => name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

export function applyBrand() {
  document.title = `${brand.displayName} Backoffice`;

  Object.entries(brand.theme).forEach(([name, value]) => {
    document.documentElement.style.setProperty(`--color-${toCssName(name)}`, value);
  });

  const favicon = document.querySelector('link[rel="icon"]');
  if (favicon) favicon.href = brand.favicon;

  const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (appleIcon) appleIcon.href = brand.logo;

  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.content = brand.theme.primary;

  const manifest = {
    short_name: brand.displayName,
    name: `${brand.displayName} Backoffice`,
    start_url: ".",
    display: "standalone",
    theme_color: brand.theme.primary,
    background_color: brand.theme.background,
    icons: [],
  };
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    manifestLink.href = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: "application/manifest+json" }));
  }
}
